<template>
  <BaseBadge
    :label="title"
    size="sm"
    :icon="icon"
    icon-class="-mr-1 text-proxify-gray-500"
    badge-class="bg-proxify-gray-100 text-proxify-gray-700"
  ></BaseBadge>
</template>

<script setup>
import BaseBadge from '@/components/Base/BaseBadge.vue';
import { computed, toRefs } from 'vue';
import { useStore } from 'vuex';
import { useChangeCase } from '@vueuse/integrations/useChangeCase';

const props = defineProps({
  referrerEmail: {
    type: String,
    required: false,
  },
  source: {
    type: String,
    required: true,
  },
  campaign: {
    type: String,
    default: null,
  },
});
const { source, campaign } = toRefs(props);

const store = useStore();
const sources = computed(() => store.state.application.sources);
const icon = computed(() => {
  return source.value === 'applied'
    ? 'globe-011'
    : source.value === 'sourced'
      ? 'search-lg'
      : 'users-01';
});
const title = computed(() =>
  campaign.value
    ? useChangeCase(campaign.value, 'capitalCase').value
    : sources.value.find((item) => item.value === source.value)?.name
);
</script>
